// Generated file : do not modify
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Ressources HTML
export class HtmlParam {
  // 
  public id: number;
  // 
  public value: string;

  constructor() {
    this.id = 0;
    this.value = '';
  }
}

export class HtmlType {
  // 
  public objType: string;
  // 
  public objName: string;

  constructor() {
    this.objType = '';
    this.objName = '';
  }
}

export default class HtmlAttrib  {
  // Identifiant unique
  public id: number;
  // Ressource
  public objType: string;
  // Code
  public objName: string;
  // Publi-contexte
  public publiContext: string;
  // Paramètres de publi-postage
  public publiParams: HtmlParam[];
  // Texte HTML avec paramètres de publi-postage
  public html: string;
  // Texte HTML pour mobile avec paramètres de publi-postage
  public htmlMobile: string;
  // Paramètres additionnels
  public sysParams: string[];
  // Label spécifique pour mobile
  public hasMobile: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.objType = '';
    this.objName = '';
    this.publiContext = '';
    this.publiParams = [];
    this.html = '';
    this.htmlMobile = '';
    this.sysParams = [];
    this.hasMobile = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: HtmlAttrib): HtmlAttrib {
    const newHtmlAttrib: HtmlAttrib = new HtmlAttrib();
    newHtmlAttrib.id = obj.id;
    newHtmlAttrib.objType = obj.objType;
    newHtmlAttrib.objName = obj.objName;
    newHtmlAttrib.publiContext = obj.publiContext;
    newHtmlAttrib.publiParams = JSON.parse(JSON.stringify(obj.publiParams));
    newHtmlAttrib.html = obj.html;
    newHtmlAttrib.htmlMobile = obj.htmlMobile;
    newHtmlAttrib.sysParams = JSON.parse(JSON.stringify(obj.sysParams));
    newHtmlAttrib.hasMobile = obj.hasMobile;
    newHtmlAttrib.canUpdate = obj.canUpdate;
    newHtmlAttrib.canDelete = obj.canDelete;
    newHtmlAttrib.display = obj.display;
    newHtmlAttrib.notifDefType = obj.notifDefType;
    return newHtmlAttrib;
  }

  public toJsonHtmlAttrib (): string {
    const json = {
      objType: this.objType,
      objName: this.objName,
      publiContext: this.publiContext,
      publiParams: this.publiParams,
      html: this.html,
      htmlMobile: this.htmlMobile,
      sysParams: this.sysParams,
      hasMobile: this.hasMobile,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromHtmlAttrib (obj: HtmlAttrib): void {
    this.id = obj.id;
    this.objType = obj.objType;
    this.objName = obj.objName;
    this.publiContext = obj.publiContext;
    this.publiParams = obj.publiParams;
    this.html = obj.html;
    this.htmlMobile = obj.htmlMobile;
    this.sysParams = obj.sysParams;
    this.hasMobile = obj.hasMobile;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareHtmlAttrib (value: HtmlAttrib): boolean {
    return (this.toJsonHtmlAttrib() == value.toJsonHtmlAttrib());
  }

  public cloneHtmlAttrib (): HtmlAttrib {
    return HtmlAttrib.fromJson(this);
  }

  public create (): Promise<HtmlAttrib> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/htmlattribs/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromHtmlAttrib(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public update (): Promise<HtmlAttrib> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/htmlattribs/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromHtmlAttrib(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public delete (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/htmlattribs/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/htmlattribs/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static listByType (type: HtmlType): Promise<HtmlAttrib[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/htmlattribs/listByType', type, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: HtmlAttrib[] = [];
              res.data.forEach(( a: HtmlAttrib ) => {
                cData.push(a);
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static listParam (publiContext: string): Promise<HtmlParam[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/htmlattribs/listParam/' + publiContext, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: HtmlParam[] = [];
              res.data.forEach(( a: HtmlParam ) => {
                cData.push(a);
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<HtmlAttrib> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/HtmlAttribs/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = HtmlAttrib.fromJson(listData.reccords[0] as HtmlAttrib);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(htmlAttribs: HtmlAttrib[]) {
  }
}
